import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import Layout from "@/components/Layout";
import ResultsTable from "@/components/ResultsTable";
import { Trash2, Loader2, Package, ArrowLeft } from "lucide-react";

export default function History() {
  const [batches, setBatches] = useState(null);
  const [selected, setSelected] = useState(null);

  const load = async () => {
    try {
      const { data } = await api.get("/batches");
      setBatches(data);
    } catch (e) {
      toast.error(apiError(e.response?.data?.detail));
    }
  };

  useEffect(() => {
    load();
  }, []);

  const open = async (id) => {
    const { data } = await api.get(`/batches/${id}`);
    setSelected(data);
  };

  const remove = async (id, e) => {
    e.stopPropagation();
    await api.delete(`/batches/${id}`);
    toast.success("Șters");
    load();
  };

  if (selected)
    return (
      <Layout>
        <div className="p-8 max-w-[1400px] mx-auto">
          <button
            onClick={() => setSelected(null)}
            data-testid="back-history"
            className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground mb-6"
          >
            <ArrowLeft size={16} /> Înapoi la istoric
          </button>
          <h1 className="text-2xl font-semibold tracking-tight mb-1">Detalii verificare</h1>
          <p className="text-sm text-muted-foreground font-mono mb-6">
            {new Date(selected.created_at).toLocaleString("ro-RO")} · {selected.awbs.length} AWB-uri
          </p>
          <ResultsTable awbs={selected.awbs} />
        </div>
      </Layout>
    );

  return (
    <Layout>
      <div className="p-8 max-w-[1100px] mx-auto">
        <h1 className="text-3xl font-semibold tracking-tight mb-1">Istoric verificări</h1>
        <p className="text-sm text-muted-foreground mb-8">Toate verificările tale anterioare.</p>

        {batches === null ? (
          <div className="flex justify-center py-16">
            <Loader2 className="animate-spin text-muted-foreground" />
          </div>
        ) : batches.length === 0 ? (
          <div className="border border-dashed border-border rounded-sm py-16 text-center text-muted-foreground font-mono text-sm">
            Nicio verificare încă
          </div>
        ) : (
          <div className="space-y-3">
            {batches.map((b) => (
              <div
                key={b.id}
                data-testid={`history-${b.id}`}
                onClick={() => open(b.id)}
                className="cursor-pointer border border-border rounded-sm bg-card p-4 flex items-center gap-5 hover:border-muted-foreground transition-colors"
              >
                <div className="h-10 w-10 rounded-sm bg-muted flex items-center justify-center shrink-0">
                  <Package size={18} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium">
                    {new Date(b.created_at).toLocaleString("ro-RO")}
                  </div>
                  <div className="text-xs text-muted-foreground font-mono truncate">
                    {b.awb_files.length} fișiere AWB · {b.decont_files.length} deconturi
                  </div>
                </div>
                <div className="flex items-center gap-6 font-mono text-sm shrink-0">
                  <span>{b.total} <span className="text-muted-foreground text-xs">AWB</span></span>
                  <span className="text-[#34C759]">{b.delivered} <span className="text-xs opacity-70">livrate</span></span>
                  <span className="text-[#4DA3FF]">{b.paid} <span className="text-xs opacity-70">plătite</span></span>
                </div>
                <button
                  onClick={(e) => remove(b.id, e)}
                  data-testid={`delete-${b.id}`}
                  className="text-muted-foreground hover:text-[#FF3B30] shrink-0"
                >
                  <Trash2 size={16} />
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
